import React from "react";
import {
	EditOutlined,
	LoadingOutlined,
	SearchOutlined,
	LeftOutlined,
	RightOutlined,
	ApiOutlined,
	ArrowLeftOutlined,
	CheckOutlined,
	AppstoreOutlined,
	BarsOutlined,
	LinkOutlined,
	CarOutlined,
	CaretRightOutlined,
	CloseOutlined,
	BookOutlined,
	BulbOutlined,
	CameraOutlined,
	CloudOutlined,
	CodeOutlined,
	CoffeeOutlined,
	CustomerServiceOutlined,
	DashboardOutlined,
	DownOutlined,
	EllipsisOutlined,
	DislikeOutlined,
	DotChartOutlined,
	EnvironmentOutlined,
	ExclamationCircleOutlined,
	ExportOutlined,
	FileOutlined,
	FlagOutlined,
	FolderOpenOutlined,
	FolderOutlined,
	ForkOutlined,
	WomanOutlined,
	LikeOutlined,
	FormOutlined,
	GlobalOutlined,
	HeartOutlined,
	HomeOutlined,
	HourglassOutlined,
	IdcardOutlined,
	InboxOutlined,
	InfoCircleOutlined,
	KeyOutlined,
	LayoutOutlined,
	MailOutlined,
	ManOutlined,
	MessageOutlined,
	MenuFoldOutlined,
	MenuUnfoldOutlined,
	MinusCircleOutlined,
	PhoneOutlined,
	PictureOutlined,
	ProfileOutlined,
	PushpinOutlined,
	QuestionCircleOutlined,
	RocketOutlined,
	SafetyCertificateOutlined,
	SaveOutlined,
	SecurityScanOutlined,
	ScheduleOutlined,
	SelectOutlined,
	SettingOutlined,
	ShareAltOutlined,
	ShopOutlined,
	ShoppingCartOutlined,
	SolutionOutlined,
	StarOutlined,
	TableOutlined,
	TagOutlined,
	TeamOutlined,
	UsbOutlined,
	UpOutlined,
	UserOutlined,
	TrophyOutlined,
	ToolOutlined,
	WifiOutlined,
	WarningOutlined,
	VideoCameraOutlined,
	SyncOutlined,
	PlusOutlined,
	LockOutlined,
	ExceptionOutlined,
	DeleteOutlined,
} from "@ant-design/icons";

export const CustomIcon = ({ title }) => {
	switch (title) {
		case "tag":
			return <TagOutlined />;
		case "loading":
			return <LoadingOutlined />;
		case "search":
			return <SearchOutlined />;
		case "edit":
			return <EditOutlined />;
		case "team":
			return <TeamOutlined />;
		case "usb":
			return <UsbOutlined />;
		case "userOutlined":
			return <UserOutlined />;
		case "trophy":
			return <TrophyOutlined />;
		case "tool":
			return <ToolOutlined />;
		case "sync":
			return <SyncOutlined />;
		case "video camera":
			return <VideoCameraOutlined />;
		case "warning":
			return <WarningOutlined />;
		case "wifi":
			return <WifiOutlined />;
		case "woman":
			return <WomanOutlined />;
		case "api":
			return <ApiOutlined />;
		case "arrowLeft":
			return <ArrowLeftOutlined />;
		case "grid":
			return <AppstoreOutlined />;
		case "bars":
			return <BarsOutlined />;
		case "book":
			return <BookOutlined />;
		case "bulb":
			return <BulbOutlined />;
		case "camera":
			return <CameraOutlined />;
		case "car":
			return <CarOutlined />;
		case "caretRight":
			return <CaretRightOutlined />;
		case "check":
			return <CheckOutlined />;
		case "close":
			return <CloseOutlined />;
		case "cloud":
			return <CloudOutlined />;
		case "code":
			return <CodeOutlined />;
		case "coffee":
			return <CoffeeOutlined />;
		case "customer-service":
			return <CustomerServiceOutlined />;
		case "dashboard":
			return <DashboardOutlined />;
		case "down":
			return <DownOutlined />;
		case "ellipsis":
			return <EllipsisOutlined />;
		case "dislike":
			return <DislikeOutlined />;
		case "dot chart":
			return <DotChartOutlined />;
		case "environment":
			return <EnvironmentOutlined />;
		case "exclamation":
			return <ExclamationCircleOutlined />;
		case "export":
			return <ExportOutlined />;
		case "lock":
			return <LockOutlined />;
		case "file":
			return <FileOutlined />;
		case "flag":
			return <FlagOutlined />;
		case "folder open":
			return <FolderOpenOutlined />;
		case "folder":
			return <FolderOutlined />;
		case "fork":
			return <ForkOutlined />;
		case "form":
			return <FormOutlined />;
		case "globe":
			return <GlobalOutlined />;
		case "heart":
			return <HeartOutlined />;
		case "home":
			return <HomeOutlined />;
		case "hourglass":
			return <HourglassOutlined />;
		case "idcard":
			return <IdcardOutlined />;
		case "inbox":
			return <InboxOutlined />;
		case "info":
			return <InfoCircleOutlined />;
		case "key":
			return <KeyOutlined />;
		case "layout":
			return <LayoutOutlined />;
		case "like":
			return <LikeOutlined />;
		case "mail":
			return <MailOutlined />;
		case "man":
			return <ManOutlined />;
		case "message":
			return <MessageOutlined />;
		case "menuFold":
			return <MenuFoldOutlined />;
		case "menuUnfold":
			return <MenuUnfoldOutlined />;
		case "minus":
			return <MinusCircleOutlined />;
		case "phone":
			return <PhoneOutlined />;
		case "picture":
			return <PictureOutlined />;
		case "profile":
			return <ProfileOutlined />;
		case "plus":
			return <PlusOutlined />;
		case "pushpin":
			return <PushpinOutlined />;
		case "question mark":
			return <QuestionCircleOutlined />;
		case "rocket":
			return <RocketOutlined />;
		case "safety":
			return <SafetyCertificateOutlined />;
		case "save":
			return <SaveOutlined />;
		case "scan":
			return <SecurityScanOutlined />;
		case "schedule":
			return <ScheduleOutlined />;
		case "link":
			return <LinkOutlined />;
		case "select":
			return <SelectOutlined />;
		case "setting":
			return <SettingOutlined />;
		case "shareAlt":
			return <ShareAltOutlined />;
		case "shop":
			return <ShopOutlined />;
		case "shopping cart":
			return <ShoppingCartOutlined />;
		case "solution":
			return <SolutionOutlined />;
		case "star":
			return <StarOutlined />;
		case "table":
			return <TableOutlined />;
		case "up":
			return <UpOutlined />;
		case "left":
			return <LeftOutlined />;
		case "right":
			return <RightOutlined />;
		case "exception":
			return <ExceptionOutlined />;
		case "delete":
			return <DeleteOutlined />;
		default:
			return <AppstoreOutlined />;
	}
};

const iconList = [
	{ icon: "lock", title: "lock" },
	{ icon: "loading", title: "loading" },
	{ icon: "search", title: "search" },
	{ icon: "edit", title: "edit" },
	{ icon: "api", title: "api" },
	{ icon: "appstore", title: "grid" },
	{ icon: "bars", title: "bars" },
	{ icon: "book", title: "book" },
	{ icon: "bulb", title: "bulb" },
	{ icon: "camera", title: "camera" },
	{ icon: "car", title: "car" },
	{ icon: "check-circle-o", title: "check" },
	{ icon: "close-circle-o", title: "close" },
	{ icon: "cloud", title: "cloud" },
	{ icon: "code-o", title: "code" },
	{ icon: "coffee", title: "coffee" },
	{ icon: "customer-service", title: "customer-service" },
	{ icon: "dashboard", title: "dashboard" },
	{ icon: "dislike", title: "dislike" },
	{ icon: "dot-chart", title: "dot chart" },
	{ icon: "ellipsis", title: "ellipsis" },
	{ icon: "environment", title: "environment" },
	{ icon: "exclamation-circle-o", title: "exclamation" },
	{ icon: "export", title: "export" },
	{ icon: "file", title: "file" },
	{ icon: "flag", title: "flag" },
	{ icon: "folder", title: "folder" },
	{ icon: "folder-open", title: "folder open" },
	{ icon: "fork", title: "fork" },
	{ icon: "form", title: "form" },
	{ icon: "global", title: "globe" },
	{ icon: "heart", title: "heart" },
	{ icon: "home", title: "home" },
	{ icon: "hourglass", title: "hourglass" },
	{ icon: "idcard", title: "idcard" },
	{ icon: "inbox", title: "inbox" },
	{ icon: "info-circle-o", title: "info" },
	{ icon: "key", title: "key" },
	{ icon: "layout", title: "layout" },
	{ icon: "like", title: "like" },
	{ icon: "link", title: "link" },
	{ icon: "mail", title: "mail" },
	{ icon: "man", title: "man" },
	{ icon: "message", title: "message" },
	{ icon: "minus-circle-o", title: "minus" },
	{ icon: "phone", title: "phone" },
	{ icon: "picture", title: "picture" },
	{ icon: "plus-circle-o", title: "plus" },
	{ icon: "profile", title: "profile" },
	{ icon: "pushpin", title: "pushpin" },
	{ icon: "question-circle-o", title: "question mark" },
	{ icon: "rocket", title: "rocket" },
	{ icon: "safety", title: "safety" },
	{ icon: "save", title: "save" },
	{ icon: "scan", title: "scan" },
	{ icon: "schedule", title: "schedule" },
	{ icon: "select", title: "select" },
	{ icon: "setting", title: "setting" },
	{ icon: "shop", title: "shop" },
	{ icon: "shopping-cart", title: "shopping cart" },
	{ icon: "solution", title: "solution" },
	{ icon: "star", title: "star" },
	{ icon: "sync", title: "sync" },
	{ icon: "table", title: "table" },
	{ icon: "tag", title: "tag" },
	{ icon: "team", title: "team" },
	{ icon: "tool", title: "tool" },
	{ icon: "trophy", title: "trophy" },
	{ icon: "usb", title: "usb" },
	{ icon: "video-camera", title: "video camera" },
	{ icon: "warning", title: "warning" },
	{ icon: "wifi", title: "wifi" },
	{ icon: "woman", title: "woman" },
];

export default iconList;
